<template>
  <nav
    :class="[
      'fixed top-0 left-0 right-0 z-50 transition-all duration-300',
      isVisible ? 'translate-y-0' : '-translate-y-full',
    ]"
  >
    <div class="sticky-nav-bg">
      <div class="container mx-auto px-4 sm:px-6">
        <div class="flex items-center justify-between h-16">
          <!-- Logo -->
          <router-link to="/" class="nav-logo">
            <span class="logo-icon">🪐</span>
            <span class="logo-text">hlly0x1</span>
            <div class="logo-underline"></div>
          </router-link>

          <!-- 导航按钮 -->
          <div class="flex items-center gap-2 sm:gap-3">
            <template v-for="item in navItems" :key="item.label">
              <!-- 普通按钮 -->
              <router-link
                v-if="!item.dropdown"
                :to="item.path"
                class="nav-button"
              >
                <span class="button-text">{{ item.label }}</span>
                <div class="button-underline"></div>
              </router-link>

              <!-- 下拉菜单按钮 -->
              <div v-else class="relative group">
                <button class="nav-button dropdown-button">
                  <span class="button-text">{{ item.label }}</span>
                  <svg
                    class="dropdown-arrow"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                  <div class="button-underline"></div>
                </button>

                <!-- 下拉菜单 -->
                <div class="dropdown-menu">
                  <router-link
                    v-for="subItem in item.dropdown"
                    :key="subItem.label"
                    :to="subItem.path"
                    class="dropdown-item"
                  >
                    <span>{{ subItem.label }}</span>
                  </router-link>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { useNavigation } from "@/composables/useNavigation";

export default {
  name: "StickyNav",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { navItems } = useNavigation();

    return {
      navItems,
    };
  },
};
</script>

<style scoped>
/* 导航栏背景 - glassmorphism */
.sticky-nav-bg {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(59, 130, 246, 0.1);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Logo 样式 */
.nav-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  position: relative;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.nav-logo:hover {
  background: rgba(59, 130, 246, 0.08);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.logo-icon {
  font-size: 1.25rem;
  animation: rotate-planet 20s linear infinite;
}

@keyframes rotate-planet {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.logo-text {
  font-family: "Airstrip", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.05em;
}

.logo-underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(to right, #3b82f6, #8b5cf6, #ec4899);
  transition: width 0.3s ease;
}

.nav-logo:hover .logo-underline {
  width: 80%;
}

/* 导航按钮样式 */
.nav-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  color: #1f2937;
  font-size: 0.9375rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: visible;
  background: transparent;
  border: none;
}

.nav-button:hover {
  background: rgba(59, 130, 246, 0.08);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.button-text {
  position: relative;
  z-index: 1;
}

/* 按钮下划线效果 */
.button-underline {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(to right, #3b82f6, #8b5cf6, #ec4899);
  transition: width 0.3s ease;
}

.nav-button:hover .button-underline {
  width: 80%;
}

/* 下拉箭头 */
.dropdown-arrow {
  width: 0.875rem;
  height: 0.875rem;
  transition: transform 0.3s ease;
}

.group:hover .dropdown-arrow {
  transform: rotate(180deg);
}

/* 下拉菜单 */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 160px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  border: 1px solid rgba(59, 130, 246, 0.15);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 0.5rem;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 50;
}

.group:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.625rem 0.875rem;
  color: #1f2937;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.dropdown-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #3b82f6, #8b5cf6);
  transform: scaleY(0);
  transition: transform 0.2s ease;
}

.dropdown-item:hover {
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.1),
    rgba(139, 92, 246, 0.1)
  );
  color: #3b82f6;
  transform: translateX(4px);
}

.dropdown-item:hover::before {
  transform: scaleY(1);
}

/* 响应式 */
@media (max-width: 640px) {
  .nav-button {
    padding: 0.375rem 0.625rem;
    font-size: 0.8125rem;
  }

  .logo-text {
    font-size: 1.125rem;
  }

  .logo-icon {
    font-size: 1rem;
  }
}
</style>
